var render = function render(){var _vm=this,_c=_vm._self._c;return _c('infoSenhas',{staticClass:"px-2 mx-2 pt-2",attrs:{"tipo":1}})
}
var staticRenderFns = []

export { render, staticRenderFns }